var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeBox"},[_c('qff-banner'),_c('qff-integration'),_c('qff-core-advantages'),_c('qff-industry-solutions'),_c('qff-number'),_c('qff-news-information'),_c('qff-customer-stories')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }